import systemSetup from '../view/systemManage/system-setup/system-setup'
//用户管理
import allUsers from '../view/systemManage/system-setup/subpage/allUsers'//全部用户
import centerUsers from '../view/systemManage/system-setup/subpage/centerUser.vue'//指挥中心用户
import regionalAuthorized from '../view/systemManage/system-setup/subpage/regional-authorized'//区域授权
import userPayStatistics from '../view/systemManage/system-setup/subpage/user-pay-statistics'//用户付费统计
//部门管理
import departmentStaffManagement from '../view/systemManage/system-setup/department/department-staff-management'//部门人员管理
import divisionManagement from '../view/systemManage/system-setup/department/division-management'//部门管理
//摄像机
import divisionLabel from '../view/systemManage/system-setup/division/division-label'//部门人员管理
import cameraManagement from '../view/systemManage/system-setup/division/camera-management'//部门管理
import gatewaysManagement from '../view/systemManage/system-setup/division/gateways-management'//网关管理
import cascadeResource from '../view/systemManage/system-setup/division/cascadeResource'//级联资源管理
//系统资源
import districtManagement from '../view/systemManage/system-setup/resources/district-management'//区域设置
import districtDraw from '../view/systemManage/system-setup/resources/district-draw'//区域设置
import menuManagement from '../view/systemManage/system-setup/resources/menu-management'//菜单设置
import menuRoleManagement from '../view/systemManage/system-setup/resources/menu-role-management'//菜单角色设置
import msgManagement from '../view/systemManage/system-setup/resources/msg-management.vue'//短信管理
//系统管理
import liquidCircle from '../view/systemManage/system-setup/system-management/liquid-circle'//雪亮圈子管理
import massControlManage from '../view/systemManage/system-setup/system-management/mass-control-manage'//群防群治管理
import operationLog from '../view/systemManage/system-setup/system-management/operation-log'//操作日志
import PCVersioning from '../view/systemManage/system-setup/system-management/PC-versioning'//PC版本管理
import versionUpgrade from '../view/systemManage/system-setup/system-management/version-upgrade'//版本升级
import systemCode from '../view/systemManage/system-setup/system-management/system-code'//系统编码
import rtspModule from '../view/systemManage/system-setup/system-management/RTSP.vue'//rtsp模板
import childPlatform from '../view/systemManage/system-setup/system-management/child-platform.vue'//子系统管理
import third from '../view/systemManage/system-setup/system-management/third'//第三方配置
import appPlatform from '../view/systemManage/system-setup/system-management/appPlatform'//应用平台管理
import wvp from '../view/systemManage/system-setup/system-management/wvp'//wvp视频平台


const test = {
    path: '/system-settings',
    component: systemSetup,
    redirect: '/system-settings/allUsers',
    children: [
   //人员管理
        {
            path: '/system-settings/allUsers',
            name: 'allUsers',
            component: allUsers,
            meta: {
                title: '全部用户'
            }
        },{
            path: '/system-settings/centerUsers',
            name: 'centerUsers',
            component: centerUsers,
            meta: {
                title: '指挥中心用户'
            }
        },
        {
            path: '/system-settings/regional-authorized',
            name: 'regional-authorized',
            component: regionalAuthorized,
            meta: {
                title: '区域认证'
            }
        },
        {
            path: '/system-settings/user-pay-statistics',
            name: 'user-pay-statistics',
            component: userPayStatistics,
            meta: {
                title: '用户付费统计'
            }
        },
    //    部门管理
        {
            path: '/system-settings/division-management',
            name: 'division-management',
            component: divisionManagement,
            meta: {
                title: '部门管理'
            }
        },
        {
            path: '/system-settings/department-staff-management',
            name: 'department-staff-management',
            component: departmentStaffManagement,
            meta: {
                title: '部门人员管理'
            }
        },
    //    摄像机
        {
            path: '/system-settings/division-label',
            name: 'divisionLabel',
            component: divisionLabel,
            meta: {
                title: '摄像机标签'
            }
        },
        {
            path: '/system-settings/camera-management',
            name: 'cameraManagement',
            component: cameraManagement,
            meta: {
                title: '摄像机管理'
            }
        },
        {
            path: '/system-settings/gateways-management',
            name: 'gatewaysManagement',
            component: gatewaysManagement,
            meta: {
                title: '网关管理'
            }
        },
        {
            path: '/system-settings/cascadeResource',
            name: 'cascadeResource',
            component: cascadeResource,
            meta: {
                title: '级联资源管理'
            }
        },
    //   系统设置
        {
            path: '/system-settings/menu-role-management',
            name: 'menuRoleManagement',
            component: menuRoleManagement,
            meta: {
                title: '菜单角色设置'
            }
        },
        {
            path: '/system-settings/menu-management',
            name: 'menuManagement',
            component: menuManagement,
            meta: {
                title: '菜单设置'
            }
        },
        {
            path: '/system-settings/district-management',
            name: 'districtManagement',
            component: districtManagement,
            meta: {
                title: '区域管理'
            }
        },
		{
			path:'/system-settings/msg-management',
			name: 'msgManagement',
            component: msgManagement,
			meta: {
			    title: '短信管理'
			}
		},
        {
            path: '/system-settings/district-draw',
            name: 'districtDraw',
            component: districtDraw,
            meta: {
                title: '区域选择'
            }
        },
    //   系统管理
        {
            path: '/system-settings/liquid-circle',
            name: 'liquidCircle',
            component: liquidCircle,
            meta: {
                title: '雪亮圈子管理'
            }
        },
        {
            path: '/system-settings/mass-control-manage',
            name: 'massControlManage',
            component: massControlManage,
            meta: {
                title: '群防群治管理'
            }
        },
        {
            path: '/system-settings/operation-log',
            name: 'operationLog',
            component: operationLog,
            meta: {
                title: '操作日志'
            }
        },
        {
            path: '/system-settings/PC-versioning',
            name: 'PCVersioning',
            component: PCVersioning,
            meta: {
                title: 'PC版本管理'
            }
        },
        {
            path: '/system-settings/version-upgrade',
            name: 'versionUpgrade',
            component: versionUpgrade,
            meta: {
                title: '版本升级'
            }
        },
        {
            path: '/system-settings/system-code',
            name: 'systemCode',
            component: systemCode,
            meta: {
                title: '系统编码'
            }
        },
        {
            path: '/system-settings/RTSP-Management',
            name: 'rtsp',
            component: rtspModule,
            meta: {
                title: 'RTSP模板管理'
            }
        },
        {
            path: '/system-settings/child-platform',
            name: 'childModule',
            component: childPlatform,
            meta: {
                title: '子平台管理'
            }
        },
        {
            path: '/system-settings/third',
            name: 'third',
            component: third,
            meta: {
                title: '第三方配置'
            }
        },
        {
            path: '/system-settings/appPlatform',
            name: 'appPlatform',
            component: appPlatform,
            meta: {
                title: '应用平台管理'
            }
        },
        {
            path: '/system-settings/wvp',
            name: 'wvp',
            component: wvp,
            meta: {
                title: 'wvp视频平台'
            }
        },
    ]
}

export default test
